import React, { useRef, useState, useEffect } from "react";
import CaSideNav from "../../../../components/AdminComponents/CaSideNav";
import SecondaryNav2 from "../../../../components/AdminComponents/SecondaryNav2";
import {
  CaAdminMenu,
  SecondaryNavCommunications,
} from "../../../../components/AdminComponents/MenuItems";

import {
  BackwardOutlined,
  FormOutlined,
  EyeTwoTone,
  EditTwoTone,
} from "@ant-design/icons";
import { useNavigate, useParams } from "react-router-dom";
import { useSelector } from "react-redux";
import {
  Input,
  Select,
  Form,
  Switch,
  Row,
  Col,
  Button,
  Drawer,
  Tooltip,
  Card,
  Skeleton,
  Tag,
  message,
  Spin,
} from "antd";
import Axios from "../../../../api/Axios";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import { quillModules } from "./helper";
import {
  capitalizeFirstLetter,
  capitalizeWords,
  getFullApplicationName,
  ModuleColor,
  UserTypeColor,
} from "../../../../components/icons/ApplicationColor";
import ThirdBar from "../../../../components/AdminComponents/ThirdBar";
const { Option } = Select;
const TriggerEdit = () => {
  const history = useNavigate();
  const userInfo = useSelector((state) => state.user);
  const [messageApi, contextHolder] = message.useMessage();
  const [loading2, setLoading2] = useState(false);
  function getCookie(name) {
    const cookies = document.cookie.split("; ");
    for (let i = 0; i < cookies.length; i++) {
      const [cookieName, cookieValue] = cookies[i].split("=");
      if (cookieName === name) {
        return cookieValue;
      }
    }
    return null;
  }
  const csrfToken = getCookie("csrftoken");
  const UpdateSuccessfull = () => {
    messageApi.open({
      type: "success",
      content: "Email trigger updated successfully",
      duration: 5,
    });
  };
  // eslint-disable-next-line no-unused-vars
  const UpdateFailed = (err = "Email trigger update failed") => {
    messageApi.open({
      type: "error",
      content: err,
      duration: 5,
    });
  };
  const Loadafter3sec = () => {
    setTimeout(() => {
      setLoading2(false);
      history("/ca-admin/organization/communications/triggers");
    }, 2000);
  };

  const onFinish = async (values) => {
    console.log(values);
    setLoading2(true);
    try {
      await Axios.put(`/mailtrigger/${id}/`, values, {
        headers: {
          "X-CSRFToken": csrfToken,
        },
      });

      UpdateSuccessfull();
      Loadafter3sec();
    } catch (err) {
      console.log(err);
      setLoading2(false);
      UpdateFailed(err?.response?.data?.detail);
    }
  };
  const formRef = useRef();
  const offset = ["one day before", "immediately", "one day after"];
  const [open, setOpen] = useState(false);
  const [templates, setTemplates] = useState([]);
  const [selectedTemplate, setSelectedTemplate] = useState(null);
  const [formData, setFormData] = useState();
  const { id } = useParams();
  console.log(selectedTemplate, "selectedTemplate");
  const [text, setText] = useState("");
  const quillRef = useRef(null);
  const showDrawer = () => {
    setOpen(true);
  };
  const onClose = () => {
    setOpen(false);
  };
  const containerStyle = {
    position: "relative",
    overflow: "hidden",
  };
  const LoadTemplates = async () => {
    try {
      const res = await Axios.get(
        `/mailtemplatelist/${userInfo?.data?.organization?.id}/`
      );
      console.log(res.data);
      setTemplates(res.data);
    } catch (err) {
      console.log(err);
    }
  };
  useEffect(() => {
    LoadTemplates();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  const [loading, setLoading] = useState(false);
  const [emailSingleTemplate, setEmailSingleTemplate] = useState({});
  const RemoveButtons = () => {
    if (emailSingleTemplate?.body) {
      const buttonRegex = /<a.*?class="button1".*?>.*?<\/a>/g;
      const removedButtonsArray =
        emailSingleTemplate.body.match(buttonRegex) || [];
      const removedButtonsString = removedButtonsArray.join(" ");
      console.log(removedButtonsString);
      const modifiedBody = emailSingleTemplate.body.replace(buttonRegex, "");
      setText(modifiedBody || "--");
    }
  };
  const LoadUserData = async () => {
    setLoading2(true);
    try {
      const res = await Axios.get(`/mailtrigger/${id}/`);
      setFormData(res.data);
      //console.log(res.data);
      setLoading2(false);
      //console.log(data);
    } catch (err) {
      setLoading2(false);
      //console.log(err);
    }
  };
  useEffect(() => {
    LoadUserData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  useEffect(() => {
    if (!loading2 && formRef.current) {
      setSelectedTemplate(formData?.template);
      formRef.current.setFieldsValue({
        // role_id: formData?.role_id,
        name: formData?.name,
        abbreviation: formData?.abbreviation,
        action_time: formData?.action_time,
        status: formData?.status,
        template: formData?.template,
        // applications: formData.applications.map((app) => app.id), /// how set here
      });
    }
  }, [loading2, formData]);
  const LoadUser = async () => {
    setLoading(true);
    try {
      const res = await Axios.get(`/mailtemplate/${selectedTemplate}`);
      //console.log(res.data);
      setEmailSingleTemplate(res.data);
      RemoveButtons();
      setLoading(false);
    } catch (err) {
      //console.log(err);
      setLoading(false);
    }
  };
  useEffect(() => {
    if (selectedTemplate !== null && open === true) {
      LoadUser();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedTemplate, open]);
  useEffect(() => {
    if (selectedTemplate !== null) {
      LoadUser();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedTemplate]);
  const handleRolesSelect = (value) => {
    setSelectedTemplate(value);
  };
  const handleReset = () => {
    setSelectedTemplate(formData?.template);
    formRef.current.setFieldsValue({
      name: formData?.name,
      abbreviation: formData?.abbreviation,
      action_time: formData?.action_time,
      status: formData?.status,
      template: formData?.template,
    });
  };
  const thirdMenuData = [
    {
      path: `/ca-admin/organization/communications/triggers/edit-trigger/${id}`,
      name: "Edit Trigger",
      icon: (
        <EditTwoTone
          style={{ fontSize: "15.5px", marginRight: "5px", margintop: "1px" }}
        />
      ),
    },
  ];
  return (
    <CaSideNav props={CaAdminMenu}>
      {contextHolder}
      <SecondaryNav2 menuItems={SecondaryNavCommunications} />
      <Spin spinning={loading2}>
        <ThirdBar menuItems={thirdMenuData} />
        <div className="form-container-2" style={containerStyle}>
          <Form
            name="complex-form"
            onFinish={onFinish}
            layout="vertical"
            ref={formRef}
            labelCol={{ span: 25 }}
            wrapperCol={{ span: 80 }}
            style={{ width: "100%", marginBottom: "150px" }}
          >
            <div className="group1">
              <div className="form-heading">
                {" "}
                {capitalizeWords("EDIT EXISTING TRIGGER")}
              </div>
              <div className="antd-test-client" style={{ marginTop: "2rem" }}>
                <Row gutter={20} style={{ marginLeft: "2rem" }}>
                  <Col xs={24} sm={12} md={10} lg={5} xl={5}>
                    <Form.Item label={<p className="my-form-lables">Name</p>}>
                      <Form.Item
                        noStyle
                        name="name"
                        rules={[
                          { required: true, message: "Name is required" },
                        ]}
                      >
                        <Input
                          className="my-form-input-antd-test"
                          placeholder="Enter trigger name"
                        />
                      </Form.Item>
                    </Form.Item>
                  </Col>

                  <Col xs={24} sm={12} md={10} lg={5} xl={5}>
                    <Form.Item
                      label={<p className="my-form-lables">Abbreviation</p>}
                    >
                      <Form.Item
                        noStyle
                        name="abbreviation"
                        rules={[
                          {
                            required: true,
                            message: "abbreviation is required",
                          },
                        ]}
                      >
                        <Input
                          className="my-form-input-antd-test"
                          placeholder="Enter abbreviation"
                        />
                      </Form.Item>
                    </Form.Item>
                  </Col>
                  <Col xs={24} sm={12} md={10} lg={5} xl={5}>
                    <Form.Item
                      label={<p className="my-form-lables">Action Time</p>}
                    >
                      <Form.Item
                        noStyle
                        name="action_time"
                        rules={[
                          {
                            required: true,
                            message: "action time is required",
                          },
                        ]}
                      >
                        <Select
                          className="my-form-input-antd-test"
                          placeholder="Select an option"
                        >
                          {offset.map((role) => (
                            <Select.Option
                              key={role}
                              value={role}
                              style={{ paddingLeft: "20px" }}
                            >
                              {capitalizeFirstLetter(role)}
                            </Select.Option>
                          ))}
                        </Select>
                      </Form.Item>
                    </Form.Item>
                  </Col>

                  <Col xs={24} sm={12} md={10} lg={5} xl={5}>
                    <Form.Item
                      label={<p className="my-form-lables">Disabled</p>}
                    >
                      <Form.Item
                        noStyle
                        name="status"
                        valuePropName="checked"
                        initialValue={true}
                      >
                        <Switch
                          checkedChildren="NO"
                          unCheckedChildren="YES"
                          defaultChecked
                          name="status"
                        />
                      </Form.Item>
                    </Form.Item>
                  </Col>
                  <Col xs={24} sm={12} md={10} lg={7} xl={7}>
                    <Form.Item
                      label={
                        <>
                          <p
                            className="my-form-lables"
                            style={{ width: "100%" }}
                          >
                            Templates
                          </p>
                        </>
                      }
                    >
                      <Form.Item
                        noStyle
                        rules={[
                          { required: true, message: "template is required" },
                        ]}
                        name="template"
                      >
                        <Select
                          className="my-form-input-antd-test"
                          placeholder="Select a template"
                          suffixIcon={
                            selectedTemplate !== null && (
                              <Tooltip title="View Selected Template">
                                <EyeTwoTone
                                  style={{
                                    fontSize: "18px",
                                    cursor: "pointer",
                                  }}
                                  onClick={showDrawer}
                                />
                              </Tooltip>
                            )
                          }
                          onChange={handleRolesSelect}
                          value={selectedTemplate}
                        >
                          {templates?.map((role, index) => (
                            <Option key={role?.id} value={role?.id}>
                              {role?.title}
                            </Option>
                          ))}
                        </Select>
                      </Form.Item>
                    </Form.Item>
                  </Col>
                  {selectedTemplate !== null &&
                    emailSingleTemplate?.application && (
                      <>
                        <Col xs={24} sm={12} md={10} lg={3} xl={3}>
                          <Form.Item
                            label={
                              <p
                                className="my-form-lables"
                                style={{ paddingLeft: "10px" }}
                              >
                                Module
                              </p>
                            }
                          >
                            <Tag
                              color={ModuleColor(
                                getFullApplicationName(
                                  emailSingleTemplate?.application
                                )
                              )}
                              title={getFullApplicationName(
                                emailSingleTemplate?.application
                              )}
                              style={{
                                fontWeight: "600",
                                marginLeft: "10px",
                                fontSize: "13.5px",
                                padding: "3px",
                                paddingInline: "5px",
                              }}
                            >
                              {getFullApplicationName(
                                emailSingleTemplate?.application
                              )?.toUpperCase() || null}
                            </Tag>
                            {/* </Select> */}
                          </Form.Item>
                        </Col>

                        <Col xs={24} sm={12} md={10} lg={5} xl={5}>
                          <Form.Item
                            label={
                              <p
                                className="my-form-lables"
                                style={{ paddingLeft: "10px" }}
                              >
                                Role Access
                              </p>
                            }
                          >
                            {emailSingleTemplate?.user_type?.map((role) => (
                              <Tag
                                color={UserTypeColor(role)}
                                key={role}
                                title={role}
                                style={{
                                  fontWeight: "600",
                                  // fontSize: "13px",
                                  fontSize: "13px",
                                  // fontFamily: "Poppins",
                                  padding: "3px",
                                  paddingInline: "5px",
                                }}
                              >
                                {role?.toUpperCase()}
                                {/* {capitalizeFirstLetter(role)} */}
                              </Tag>
                            ))}
                          </Form.Item>
                        </Col>
                      </>
                    )}
                </Row>
              </div>
            </div>
            <div style={{ display: "inline-block", marginLeft: "5rem" }}>
              <Form.Item label=" " colon={false}>
                <Button
                  type="text"
                  htmlType="button"
                  style={{
                    background: "#D3D3D3",
                  }}
                  onClick={() => {
                    history(`/ca-admin/organization/communications/triggers`);
                  }}
                >
                  <BackwardOutlined />
                  Back
                </Button>
              </Form.Item>
            </div>

            <div style={{ display: "inline-block", marginLeft: "16px" }}>
              <Form.Item label=" " colon={false}>
                <Button type="primary" htmlType="button" onClick={handleReset}>
                  Reset
                </Button>
              </Form.Item>
            </div>
            <div style={{ display: "inline-block", marginLeft: "16px" }}>
              <Form.Item label=" " colon={false}>
                <Button
                  type="primary"
                  htmlType="submit"
                  // className="my-form-input-end"
                  style={{
                    background: "#f58029",
                    fontWeight: "600",
                  }}
                  className="save-update-btn"
                >
                  Update
                  <FormOutlined />
                </Button>
              </Form.Item>
            </div>
          </Form>
          <Drawer
            title={
              <p className="modal-heading" style={{ fontWeight: "500" }}>
                SELECTED TEMPLATE DETAILS
              </p>
            }
            placement="right"
            closable={true}
            onClose={onClose}
            open={open}
            size="large"
            getContainer={false}
          >
            {loading ? (
              <Skeleton active loading={loading} size="small" />
            ) : (
              <>
                <Card
                  hoverable
                  headStyle={{
                    backgroundColor: "#353935",
                    color: "white",
                    padding: "5.5px",
                  }}
                  bodyStyle={{ padding: 20 }}
                  title={
                    <span
                      style={{
                        color: "white",
                        paddingLeft: "20px",
                        fontFamily: "Poppins",
                        fontWeight: 500,
                        fontSize: "15px",
                      }}
                    >
                      {emailSingleTemplate?.title}
                    </span>
                  }
                >
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      marginBottom: "20px",
                    }}
                  >
                    <div
                      className="my-form-lables-withoutoverFlow"
                      style={{
                        fontSize: "14px",
                        paddingInline: "5px",
                        minWidth: "120px",
                      }}
                    >
                      EMAIL SUBJECT :
                    </div>
                    <Input
                      placeholder="Enter the email subject"
                      className="my-form-input-antd-test-without-border"
                      style={{
                        marginLeft: "10px",
                      }}
                      value={emailSingleTemplate?.subject}
                      disabled
                    />
                  </div>
                  <ReactQuill
                    theme="snow"
                    value={text}
                    onChange={setText}
                    modules={quillModules}
                    ref={quillRef}
                    readOnly={true}
                    style={{
                      maxHeight: "200px",
                      marginBottom: "20px",
                      fontFamily: "Poppins",
                    }}
                  />
                </Card>
              </>
            )}
          </Drawer>
        </div>
      </Spin>
    </CaSideNav>
  );
};

export default TriggerEdit;
